export default __webpack_public_path__ + "static/media/P2_Micropipette.74630588.svg";